<template>
  <div>
    <div class="flex w-full justify-between items-center px-4 py-2 bg-pitch-black-900">
      <div class="flex items-center pt-1 flex-1 min-w-0">
        <!-- Back button -->
        <button @click="goBack" class="text-prime-golden text-lg mr-3 flex-shrink-0">
          <img src="@/assets/images/left-chevron.svg" alt="Back" width="16" height="16" />
        </button>

        <div class="flex items-center gap-2 w-fit flex-1 min-w-0">
          <h1
            class="min-w-0 text-lg sm:text-xl md:text-2xl font-semibold whitespace-nowrap overflow-hidden text-ellipsis truncate"
            :title="projectName"
          >
            {{ projectName }}
          </h1>

          <!-- Simulation tag (only if is_simulation) -->
          <span
            v-if="is_simulation"
            class="flex-shrink-0 inline-block font-medium text-xs whitespace-nowrap text-prime-golden bg-dark-grey rounded-md px-2 py-1 mr-2 border border-charcoal-grey"
          >
            simulation
          </span>
        </div>
      </div>
      <div class="flex items-center">
        <!-- <button
          v-if="role === 'admin'"
          @click="openDeleteModal"
          class="text-prime-golden mx-2 mt-1"
        >
          <i class="fas fa-trash-alt"></i>
        </button> -->
        <!-- Communication Icon (Opens Communication Drawer) -->
        <button
          @click="toggleCommDrawer"
          class="text-prime-golden text-lg mr-[-4px] mb-[-4px]"
        >
          <img src="@/assets/images/edit.svg" alt="Edit" width="36" height="36" />
        </button>
      </div>
    </div>

    <!-- Tabs Section -->
    <div
      class="flex justify-between px-3 bg-pitch-black-900 border-b-2 border-prime-golden-100 py-2 pb-3"
    >
      <button
        :class="[
          'font-bold px-2 rounded-full h-[24px]',
          currentTab === 'overview'
            ? 'text-pitch-black bg-prime-golden text-xs border border-1 border-prime-golden-dark'
            : 'text-prime-golden text-xs',
        ]"
        @click="switchTab('overview')"
      >
        Overview
      </button>
      <button
        :class="[
          'font-bold px-2 flex items-center rounded-full h-[24px]',
          currentTab === 'log'
            ? 'text-pitch-black bg-prime-golden text-xs border border-1 border-prime-golden-dark'
            : 'text-prime-golden text-xs',
        ]"
        @click="switchTab('log')"
      >
        Inbox
        <span
          :class="[
            'ml-1 mr-[-2px]  border rounded-full w-4 h-4 text-[10px] font-bold flex justify-center items-center',
            currentTab === 'log'
              ? 'bg-prime-golden text-pitch-black border-pitch-black-300'
              : 'bg-pitch-black text-prime-golden border-total-white-300',
          ]"
        >
          {{ logsCount }}
        </span>
      </button>
      <button
        :class="[
          'font-bold px-2 rounded-full h-[24px]',
          currentTab === 'files'
            ? 'text-pitch-black bg-prime-golden text-xs border border-1 border-prime-golden-dark'
            : 'text-prime-golden text-xs',
        ]"
        @click="switchTab('files')"
      >
        Files
      </button>
      <button
        :class="[
          'font-bold px-2 rounded-full h-[24px]',
          currentTab === 'contacts'
            ? 'text-pitch-black bg-prime-golden text-xs border border-1 border-prime-golden-dark'
            : 'text-prime-golden text-xs',
        ]"
        @click="switchTab('contacts')"
      >
        Contacts
      </button>
    </div>

    <!-- Communication Drawer -->
    <CommunicationDrawer
      :isOpen="isCommDrawerOpen"
      :projectId="projectId"
      :currentTab="currentTab"
      @close="toggleCommDrawer"
      @emailSelected="handleEmailSelected"
    />
  </div>
</template>

<script>
import CommunicationDrawer from "@/components/CommunicationDrawer.vue";
export default {
  components: {
    CommunicationDrawer,
  },
  props: {
    projectName: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
    is_simulation: {
      type: Boolean,
      required: true,
    },
    currentTab: {
      type: String,
      required: true, // Receiving currentTab from the parent
    },
    role: {
      type: String,
      required: true,
    },
    logsCount: {
      type: Number,
      required: true,
    },
    from: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      isCommDrawerOpen: false, // Communication drawer visibility state
    };
  },
  methods: {
    goBack() {
      if (this.from && this.from[0] == "activation") {
        this.$router.push({
          name: "ViewActivationPage",
          params: { id: this.projectId },
        });
      } else if (this.from && this.from[0] == "agent") {
        this.$router.push({
          name: "AgentViewPage",
          params: { id: this.from[1] },
        });
      } else if (this.from && this.from[0] == "account") {
        this.$router.push({
          name: "UserAccount",
        });
      } else {
        this.$router.push({
          name: "ProjectsPage",
        });
      }
    },
    switchTab(tab) {
      this.$emit("setTab", tab); // Emit the tab switch event to parent
    },
    toggleCommDrawer() {
      this.isCommDrawerOpen = !this.isCommDrawerOpen; // Toggle communication drawer
    },
    openDeleteModal() {
      this.$emit("openDeleteModal");
    },
    handleEmailSelected() {
      this.isCommDrawerOpen = false;
      this.$router.push({
        name: "NewEmail",
        params: { selectedProject: this.projectName, projectId: this.projectId },
        query: { projectId: this.projectId },
      });
    },
  },
};
</script>

<style scoped>
/* Add any necessary styles here */
</style>
